//creamos el context el un archivo aparte para mantener orden.

import { createContext } from 'react';

const formContext = createContext();

export default formContext;